import Box from "glesys-controlpanel/components/box";
import { t } from "ember-intl";

<template>
  <Box data-test-database-details-resources ...attributes>
    <span class="text-black text-sm">{{t "label.resources"}}</span>
    <div class="text-2xl 4xl:test-3xl text-black mt-2">
      {{@database.plan.cpucores}}
      {{t "label.cores" amount=@database.plan.cpucores}}
      /
      {{@database.plan.memoryingib}}
      GiB /
      {{@database.plan.storageingib}}
      GiB
    </div>
  </Box>
</template>
